/**
 * Master JavaScript File for Theme Customizations
 * Contains all custom interactions. Vanilla JS only (No jQuery).
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ============================================================================
     [1] Sticky Header Logic
     ----------------------------------------------------------------------------
     Adds a shadow/class to the header when scrolling past a certain point.
     ========================================================================= */
  const header = document.querySelector('.custom-header');

  if (header) {
    let lastScroll = 0;

    window.addEventListener('scroll', function () {
      const currentScroll = window.scrollY;

      // If we scroll past 50 pixels from the top
      if (currentScroll > 50) {
        header.classList.add('is-sticky');

        // Hide header when scrolling down, show when scrolling up
        if (currentScroll > lastScroll) {
          // Scrolling down
          document.body.classList.add('custom-header-hidden');
        } else {
          // Scrolling up
          document.body.classList.remove('custom-header-hidden');
        }
      } else {
        header.classList.remove('is-sticky');
        document.body.classList.remove('custom-header-hidden');
      }

      lastScroll = currentScroll;
    });
  }

  /* ============================================================================
     [2] Mega Menu Open/Close (Hover on desktop, Tap on mobile)
     ----------------------------------------------------------------------------
     Handles interactions for showing/hiding the mega menu.
     ========================================================================= */
  const navItems = document.querySelectorAll('.custom-header__nav-item');

  navItems.forEach(item => {
    // For mobile: toggling menu on click if it has a dropdown
    item.addEventListener('click', function (e) {
      // Check if it's a mobile screen (adjust breakpoint as needed)
      if (window.innerWidth <= 768) {
        const megaMenu = this.querySelector('.custom-mega-menu');
        if (megaMenu) {
          // Prevent default link behavior to toggle menu instead
          e.preventDefault();
          megaMenu.style.display = (megaMenu.style.display === 'block') ? 'none' : 'block';
        }
      }
    });
  });

  /* ============================================================================
     [3] Appstle Widget Enhancements
     ----------------------------------------------------------------------------
     Any custom JS needed specifically for the Appstle widget functionality.
     ========================================================================= */
  // Example: Listen for changes in the Appstle widget (if needed)
  // document.addEventListener('appstle:widget:loaded', function(e) {
  //   console.log('Appstle widget loaded!', e);
  // });

});
